import React from 'react'

export default function BlogIntro() {
    return (
        <div className="blog-header">
        </div>
    )
}
